import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '@shared/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './edit-password.component.html',
  styleUrls: ['./../login/login.component.scss', './edit-password.component.scss'],
  standalone: false
})
export class EditPasswordComponent implements OnInit {
  @Input() repeatPassword: string;
  error = false;
  isPasswordInvalid = true;
  hidePasswordHints = true;
  loading = false;
  passwordToken: string;
  passwordMatch = false;
  resetForm: FormGroup;
  serverError = false;
  showPass = {
    newPassword: false,
    confirmPassword: false,
    repeat_pass: false
  };

  get passwordControl(): AbstractControl | null {
    return this.resetForm.get('password');
  }

  get confirmPasswordControl(): AbstractControl | null {
    return this.resetForm.get('repeatPassword');
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private act_router: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.resetForm = this.formBuilder.group({
      password: [''],
      repeatPassword: ['']
    });

    // check if the url contains in query a Token parameter
    this.act_router.queryParamMap.subscribe((queryParams) => {
      this.passwordToken = queryParams.get('reset_password_token');
    });
  }

  passVisibility(pass: string): void {
    this.showPass[pass] = !this.showPass[pass];
  }

  passwordChange(): void {
    this.error = false;
    this.serverError = false;

    const { password, repeatPassword }: { password: string; repeatPassword: string } = this.resetForm.value;
    this.passwordMatch = password === repeatPassword && !!(password.length && repeatPassword.length);
  }

  setPassword(): void {
    // check dobule click
    if (this.loading || this.isPasswordInvalid || this.resetForm.invalid) {
      return;
    }

    // double check password match
    this.passwordChange();
    if (!this.passwordMatch) {
      return;
    }

    this.loading = true;

    const { password, repeatPassword } = this.resetForm.value;
    this.authService
      .updatePassword({
        password: password,
        password_confirmation: repeatPassword,
        reset_password_token: this.passwordToken
      })
      .subscribe(
        () => {
          this.loading = false;
          this.authService.logout();
        },
        () => {
          this.error = false;
          this.serverError = true;
          this.loading = false;
          this.passwordMatch = true;
        }
      );
  }

  onIsPasswordInvalid(event) {
    setTimeout(() => {
      this.isPasswordInvalid = event;
    });
  }
}
